import { translate } from '@utils/i18n';
export const namespace = 'features.customer_portal.deficiencies';
export const CACHE_KEY = 'portal/deficiencies/index';
export const COLUMNS_CACHE_KEY = 'portal/deficiencies/columns';
export const BUILDINGS_COLUMNS_CACHE_KEY = 'portal/buildings/deficiencies/columns';
export const getCacheKey = (buildingId) => {
    return buildingId ? null : CACHE_KEY;
};
export const getColumnsCacheKey = (buildingId) => {
    return buildingId ? BUILDINGS_COLUMNS_CACHE_KEY : COLUMNS_CACHE_KEY;
};
export const ALL_COLUMNS = ['id', 'inspection', 'building', 'dateOpened', 'resolved', 'systemAsset'];
export function getColumnsConfig(DeficiencyIdCell, InspectionIdCell, BuildingCell, DetailsCell, ResolvedCell) {
    return {
        id: {
            id: 'id',
            field: 'id',
            title: translate('deficiency_number', { namespace }),
            cell: DeficiencyIdCell,
            sortable: true,
            width: 150
        },
        inspection: {
            id: 'inspection',
            field: 'inspection',
            title: translate('inspection_number', { namespace }),
            cell: InspectionIdCell,
            sortable: true,
            width: 150
        },
        building: {
            id: 'building',
            field: 'building',
            title: translate('building', { namespace }),
            cell: BuildingCell,
            sortable: true,
            width: 350
        },
        dateOpened: {
            id: 'dateOpened',
            field: 'dateOpened',
            title: translate('date_opened', { namespace }),
            sortable: true,
            width: 150
        },
        resolved: {
            id: 'resolved',
            field: 'isResolved',
            title: translate('resolved', { namespace }),
            cell: ResolvedCell,
            sortable: true,
            width: 120
        },
        systemAsset: {
            id: 'systemAsset',
            field: 'details',
            title: translate('system_asset', { namespace }),
            cell: DetailsCell,
            sortable: false,
            width: 500
        }
    };
}
